<template>
  <v-tab-item :value="$route.path" class="pa-3">
    <v-row class="mt-2 d-flex align-center mb-3">
      <v-col cols="12" lg="4" sm="6" class="pa-0">
        <v-row class="mt-2 d-flex align-center">
          <v-col cols="2">
            <ExportLinks export-key="subscriptions" :filters="filtersData" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="8" sm="6" class="pa-2">
        <v-row>
          <v-col cols="12" xl="3" lg="6" sm="12" class="d-flex align-center pt-0 pb-0">
            <b-select
              :items="statuses"
              v-model="status"
              :label="translations.status[lang]"
            ></b-select>
          </v-col>

          <v-col cols="12" xl="3" lg="6" sm="12" class="d-flex align-center mt-3 pt-0 pb-0">
            <b-search-field v-model="filtersData.q" class="mt-2"></b-search-field>
          </v-col>
          <v-col cols="12" xl="3" lg="6" sm="12">
            <v-menu :close-on-content-click="false" offset-y max-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :label="translations.startDate[lang]"
                  color="secondary"
                  autocomplete="off"
                  hint="YYYY/DD format"
                  rounded
                  outlined
                  dense
                  clearable
                  hide-details
                  :prepend-inner-icon="icons.mdiCalendarSearch"
                  v-on="on"
                  v-model="filtersData.from_date"
                  class="mt-4"
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="filtersData.from_date"
                color="secondary"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" xl="3" lg="6" sm="12">
            <v-menu :close-on-content-click="false" offset-y max-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :label="translations.endDate[lang]"
                  color="secondary"
                  autocomplete="off"
                  hint="YYYY/DD format"
                  rounded
                  outlined
                  dense
                  clearable
                  hide-details
                  :prepend-inner-icon="icons.mdiCalendarSearch"
                  v-on="on"
                  v-model="filtersData.to_date"
                  class="mt-4"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filtersData.to_date"
                color="secondary"
                :min="minEndDate"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-sheet outlined style="overflow: auto">
      <v-sheet width="1550">
        <b-data-table
          :headers="headers"
          :items="storeSubscriptions"
          :page.sync="page"
          @page-sync="(p) => (page = p)"
          class="b-outlined"
          disable-sort
        >
          <template v-slot:item.store_subscription_plan.plan_price="{ item }">
            <div v-if="item.store_subscription_plan.system_subscription_plan_payment_type">
              <span
                v-if="
                  item.store_subscription_plan.system_subscription_plan_payment_type
                    .system_subscription_plan_payment_type_id == 1 ||
                  item.store_subscription_plan.system_subscription_plan_payment_type.system ==
                    'fixed'
                "
              >
                <v-icon small v-text="icons.mdiCurrencyEur"></v-icon>
                {{ item.store_subscription_plan.plan_price }}
              </span>
              <span
                v-else-if="
                  item.store_subscription_plan.system_subscription_plan_payment_type
                    .system_subscription_plan_payment_type_id == 2 ||
                  item.store_subscription_plan.system_subscription_plan_payment_type.system ==
                    'percentage'
                "
              >
                <v-icon small v-text="icons.mdiPercent"></v-icon>
                {{ item.store_subscription_plan.plan_price }}
              </span>
            </div>
            <div v-else>-</div>
          </template>

          <template v-slot:item.active="{ item }">
            <v-switch
              v-model="item.active"
              color="success"
              @change="changeSubscriptionSettings(item, 'active')"
              hide-details
              :loading="loadingSettings[`_${item.store_subscription_id}`] == 'active'"
              :disabled="
                !!loadingSettings[`_${item.store_subscription_id}`] &&
                loadingSettings[`_${item.store_subscription_id}`] !== 'active'
              "
            ></v-switch>

            <v-icon v-if="item.active" color="green" v-text="icons.mdiCheckCircleOutline"></v-icon>
            <v-icon v-else color="red" v-text="icons.mdiMinusCircleOutline"></v-icon>
          </template>

          <template v-slot:item.due_date_invoice="{ item }">
            <v-switch
              v-model="item.due_date_invoice"
              color="success"
              @change="changeSubscriptionSettings(item, 'due_date_invoice')"
              hide-details
              :loading="loadingSettings[`_${item.store_subscription_id}`] == 'due_date_invoice'"
              :disabled="
                !!loadingSettings[`_${item.store_subscription_id}`] &&
                loadingSettings[`_${item.store_subscription_id}`] !== 'due_date_invoice'
              "
            ></v-switch>

            <v-icon
              v-if="item.due_date_invoice"
              color="green"
              v-text="icons.mdiCheckCircleOutline"
            ></v-icon>
            <v-icon v-else color="red" v-text="icons.mdiMinusCircleOutline"></v-icon>
          </template>

          <template v-slot:item.start_date="{ item }">
            {{ item.start_date.substring(0, 10) }}
          </template>

          <template v-slot:item.expiration_date="{ item }">
            {{ item.expiration_date && item.expiration_date.substring(0, 10) }}
          </template>
          <template v-slot:item.created_at="{ item }">
            {{ item.created_at.substring(0, 10) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip color="secondary" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                  @click="
                    () => {
                      storeSubscriptionInfo = item;
                      infoDialog = true;
                    }
                  "
                >
                  <v-icon v-text="icons.mdiEye"></v-icon>
                </v-btn>
              </template>

              <span
                class="font-weight-bold"
                v-text="translations.showStoreSubscriptionInfo[lang]"
              ></span>
            </v-tooltip>

            <v-tooltip
              color="secondary"
              top
              v-if="
                item.open_payment &&
                (!item.store_payment_method ||
                  !item.store_payment_method.system_payment_method_category
                    .system_payment_method_category_online)
              "
            >
            </v-tooltip>

            <v-tooltip color="secondary" top v-if="item.active && !item.cancelled">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="openCancelDialog(item)">
                  <v-icon v-text="icons.mdiCancel"></v-icon>
                </v-btn>
              </template>

              <span class="font-weight-bold" v-text="translations.cancelSubscription[lang]"></span>
            </v-tooltip>

            <v-tooltip color="secondary" top v-if="superUser && store.is_roadcube">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="openManagementDialog(item)">
                  <v-icon v-text="icons.mdiCogOutline"></v-icon>
                </v-btn>
              </template>

              <span
                class="font-weight-bold"
                v-text="translations.subscriptionManagement[lang]"
              ></span>
            </v-tooltip>
          </template>
        </b-data-table>

        <v-dialog v-model="infoDialog" max-width="800">
          <StoreSubscriptionInfo @cancel="infoDialog = false" />
        </v-dialog>

        <v-dialog v-model="cancelDialog" max-width="500">
          <b-card
            v-if="cancelingSubscription"
            type="delete"
            :title="translations.cancelSubscription[lang]"
            :loading="loading"
            :error-message="errorMessage"
            :submit-text="translations.submit"
            @cancel="closeCancelDialog()"
            @submit="changeSubscriptionSettings(cancelingSubscription, 'cancel', true)"
          >
            <div class="subtitle-1 font-weight-medium pl-2">
              {{ translations.sureCancelSubscriptionOf[lang] }}
              <span class="font-weight-bold text--primary">{{
                cancelingSubscription.store ? cancelingSubscription.store.name : ''
              }}</span
              >{{ translations.questionmark[lang] }}
            </div>
          </b-card>
        </v-dialog>

        <v-dialog v-model="managementDialog" max-width="500">
          <b-card
            v-if="superUser && store.is_roadcube"
            :title="translations.subscriptionManagement[lang]"
            :loading="loading"
            :error-message="errorMessage"
            :submit-text="translations.submit"
            @cancel="closeManagementDialog()"
            @submit="submitStoreSubscriptionManagement"
          >
            <b-text-field
              v-model="managementSettings.unpaid_days_before_inactive_store"
              type="number"
              :label="translations.daysToInactiveStore[lang]"
              min="0"
              :success="success.unpaid_days_before_inactive_store"
              :error-messages="error.unpaid_days_before_inactive_store"
              @focus="error.unpaid_days_before_inactive_store = ''"
              @blur="validateInt('unpaid_days_before_inactive_store')"
            />
            <b-text-field
              v-model="managementSettings.unpaid_days_before_inactive_campaigns"
              type="number"
              :label="translations.daysToInactiveCampaigns[lang]"
              min="0"
              :success="success.unpaid_days_before_inactive_campaigns"
              :error-messages="error.unpaid_days_before_inactive_campaigns"
              @focus="error.unpaid_days_before_inactive_campaigns = ''"
              @blur="validateInt('unpaid_days_before_inactive_campaigns')"
            />
            <b-text-field
              v-model="managementSettings.unpaid_days_before_inactive_pos"
              type="number"
              :label="translations.daysToInactivePOS[lang]"
              min="0"
              :success="success.unpaid_days_before_inactive_pos"
              :error-messages="error.unpaid_days_before_inactive_pos"
              @focus="error.unpaid_days_before_inactive_pos = ''"
              @blur="validateInt('unpaid_days_before_inactive_pos')"
            />
            <b-text-field
              v-model="managementSettings.unpaid_days_before_no_sms_pos"
              type="number"
              :label="translations.daysToDisableSMS[lang]"
              min="0"
              :success="success.unpaid_days_before_no_sms_pos"
              :error-messages="error.unpaid_days_before_no_sms_pos"
              @focus="error.unpaid_days_before_no_sms_pos = ''"
              @blur="validateInt('unpaid_days_before_no_sms_pos')"
            />
          </b-card>
        </v-dialog>
      </v-sheet>
    </v-sheet>
  </v-tab-item>
</template>

<script>
import translations from '@/utils/translations/loyaltyPanel/subscriptions/stores';
import {
  mdiCheckCircleOutline,
  mdiMinusCircleOutline,
  mdiEye,
  mdiCurrencyEur,
  mdiPercent,
  mdiReload,
  mdiCancel,
  mdiCogOutline,
} from '@mdi/js';
import { mapState, mapMutations, mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import StoreSubscriptionInfo from '@/components/loyaltyPanel/subscriptions/StoreSubscriptionInfo.vue';
import ExportLinks from '@/components/general/ExportLinks.vue';
import moment from 'moment';

export default {
  name: 'Pending',

  mixins: [translations],

  components: { StoreSubscriptionInfo, ExportLinks },

  data() {
    return {
      icons: {
        mdiCheckCircleOutline,
        mdiMinusCircleOutline,
        mdiEye,
        mdiCurrencyEur,
        mdiPercent,
        mdiReload,
        mdiCancel,
        mdiCogOutline,
      },
      page: +this.$route.query.page,
      search: '',
      infoDialog: false,
      activeStores: false,
      status: 'All',
      filtersData: {
        active: +this.$route.query.active || undefined,
        q: +this.$route.query.q || '',
        from_date: +this.$route.query.from_date || null,
        to_date: +this.$route.query.to_date || null,
      },
      cancelDialog: false,
      cancelingSubscription: null,
      loadingSettings: {},
      managementDialog: false,
      managementSettings: {
        unpaid_days_before_inactive_store: 0,
        unpaid_days_before_inactive_campaigns: 0,
        unpaid_days_before_inactive_pos: 0,
        unpaid_days_before_no_sms_pos: 0,
      },
      error: {
        unpaid_days_before_inactive_store: '',
        unpaid_days_before_inactive_campaigns: '',
        unpaid_days_before_inactive_pos: '',
        unpaid_days_before_no_sms_pos: '',
      },
      success: {
        unpaid_days_before_inactive_store: false,
        unpaid_days_before_inactive_campaigns: false,
        unpaid_days_before_inactive_pos: false,
        unpaid_days_before_no_sms_pos: false,
      },
      managementSettingsSubscriptionId: null,
    };
  },

  computed: {
    ...mapState(['loading', 'superUser', 'errorMessage', 'serverItemsLength', 'store']),

    ...mapState('loyaltyPanel/subscriptions/storeSubscriptions', ['storeSubscriptions']),
    lang() {
      return this.$route.params.lang;
    },

    minEndDate() {
      return this.filtersData && this.filtersData.from_date
        ? moment(this.filtersData.from_date).format('YYYY-MM-DD')
        : '1000-12-31';
    },

    filtersQuery() {
      let query = '';
      for (const [key, value] of Object.entries(this.filtersData)) {
        if (value || value === false) query += `&${key}=${value}`;
      }
      return query;
    },

    statuses() {
      return [
        {
          text: this.translations.all[this.lang],
          value: 'All',
        },
        {
          text: this.translations.activeCol[this.lang],
          value: 'Active',
        },
        {
          text: this.translations.inactive[this.lang],
          value: 'Inactive',
        },
      ];
    },

    storeSubscriptionInfo: {
      get() {
        return this.$store.state.loyaltyPanel.subscriptions.storeSubscriptions
          .storeSubscriptionInfo;
      },
      set(val) {
        this.setStoreSubscriptionInfo(val);
      },
    },

    query() {
      return '?page=' + this.page + this.filtersQuery;
    },

    headers() {
      return [
        {
          text: this.translations.name[this.lang],
          value: `store_subscription_plan.plan_name['${this.lang}']`,
        },
        {
          text: this.translations.storeName[this.lang],
          value: `store.app_name`,
        },
        {
          text: this.translations.activeCol[this.lang],
          value: `active`,
        },
        {
          text: this.translations.dueDateInvoice[this.lang],
          value: `due_date_invoice`,
        },
        {
          text: this.translations.price[this.lang],
          value: `store_subscription_plan.plan_price`,
        },
        {
          text: this.translations.storeCode[this.lang],
          value: 'store.store_code',
        },
        {
          text: this.translations.startDate[this.lang],
          value: 'start_date',
        },
        {
          text: this.translations.expirationDate[this.lang],
          value: 'expiration_date',
        },
        {
          text: this.translations.createdAt[this.lang],
          value: 'created_at',
        },
        {
          text: this.translations.actions[this.lang],
          value: 'actions',
        },
      ];
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/subscriptions/storeSubscriptions', [
      'getStoreSubscriptions',
      'updateSettings',
      'updateUnpaidSettings',
    ]),

    ...mapMutations('loyaltyPanel/subscriptions/storeSubscriptions', ['setStoreSubscriptionInfo']),
    ...mapMutations(['setResetValidation', 'setResetSuccess', 'setNotification']),
    handleSearch() {
      let body = {
        query: this.query,
      };
      this.getStoreSubscriptions(body);
    },

    openCancelDialog(item) {
      this.cancelingSubscription = item;
      this.cancelDialog = true;
    },

    closeCancelDialog() {
      this.cancelingSubscription = null;
      this.cancelDialog = false;
    },

    async changeSubscriptionSettings(item, setting, val = null) {
      let body = { [setting]: val || item[setting] };

      this.loadingSettings[`_${item.store_subscription_id}`] = setting;
      let res = await this.updateSettings({
        id: item.store_subscription_id,
        body,
      });
      this.loadingSettings[`_${item.store_subscription_id}`] = '';
      if (res?.code === 200) {
        await this.getStoreSubscriptions({
          query: this.query,
        });
        let settingTranslationKey = setting === 'active' ? `${setting}_${item.active}` : setting;
        let text =
          this.translations.success[this.lang] +
          this.translations[settingTranslationKey][this.lang] +
          this.translations.subscriptionFor[this.lang] +
          item.store.app_name;
        this.setNotification({
          show: true,
          type: 'success',
          text,
        });
      } else {
        if (val === null) {
          item[setting] = !item[setting];
        }
      }
      this.closeCancelDialog();
    },
    openManagementDialog(item) {
      this.managementSettings = { ...item.store_subscription_settings };
      this.managementSettingsSubscriptionId = item.store_subscription_id;
      this.managementDialog = true;
    },

    async submitStoreSubscriptionManagement() {
      Object.keys(this.managementSettings).forEach(this.validateInt);
      if (Object.values(this.error).some((e) => e)) {
        this.setNotification({
          show: true,
          type: 'error',
          text: this.translations.invalidInput[this.lang],
        });
        return;
      }
      await this.updateUnpaidSettings({
        id: this.managementSettingsSubscriptionId,
        body: this.managementSettings,
      });
      this.managementDialog = false;
      this.closeManagementDialog();
    },

    closeManagementDialog() {
      this.managementSettings = {
        unpaid_days_before_inactive_store: 0,
        unpaid_days_before_inactive_campaigns: 0,
        unpaid_days_before_inactive_pos: 0,
        unpaid_days_before_no_sms_pos: 0,
      };
      this.managementDialog = false;
      this.managementSettingsSubscriptionId = null;
      this.error = {
        unpaid_days_before_inactive_store: '',
        unpaid_days_before_inactive_campaigns: '',
        unpaid_days_before_inactive_pos: '',
        unpaid_days_before_no_sms_pos: '',
      };
      this.success = {
        unpaid_days_before_inactive_store: false,
        unpaid_days_before_inactive_campaigns: false,
        unpaid_days_before_inactive_pos: false,
        unpaid_days_before_no_sms_pos: false,
      };
    },

    validateInt(key) {
      this.success[key] = false;
      const value = Number(this.managementSettings[key]);
      if (!Number.isInteger(value) || value < 0) {
        this.error[key] = this.translations.invalidInput[this.lang];
      } else {
        this.error[key] = '';
        this.success[key] = true;
        this.managementSettings[key] = value;
      }
    },
  },

  mounted() {
    this.filtersData.q = this.$route.query.q || '';
    this.filtersData.from_date = this.$route.query.from_date || null;
    this.filtersData.to_date = this.$route.query.to_date || null;
    if (this.$route.query.active === 'true') {
      this.filtersData.active = true;
      this.status = 'Active';
    } else if (this.$route.query.active === 'false') {
      this.filtersData.active = false;
      this.status = 'Inactive';
    }
    let body = {
      query: this.query,
    };
    this.getStoreSubscriptions(body);
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.push({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },

  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },

  watch: {
    $route(val) {
      if (!val.query.page) {
        this.$router.push({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
      this.debouncedSearch;
    },

    status(val) {
      if (val == 'Active') {
        this.filtersData.active = true;
      } else if (val == 'Inactive') {
        this.filtersData.active = false;
      } else {
        this.filtersData.active = undefined;
      }
    },

    page(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
      this.handleSearch();
    },

    filtersData: {
      handler(val) {
        for (const [key, value] of Object.entries(this.filtersData)) {
          if (!!value || value === false) {
            this.$router.push({
              query: { ...this.$route.query, [key]: value },
            });
          }
        }
        this.debouncedSearch();
      },
      deep: true,
    },
  },
};
</script>
